<script lang="ts">
import { ref, watch, defineComponent } from 'vue';
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import { useRouter } from 'vue-router';
export default defineComponent({
    name: 'Breadcrumb',
    components: {},
    setup() {
        const { currentRoute } = useRouter();
        const breadcrumbItems = ref();
        const breadcrumbArr = ref([]);
        const breadcrumbLang = ref(false);
        // 监听当前路由的name变化
        watch(
            () => currentRoute.value,
            (route: RouteLocationNormalizedLoaded) => {
                let arr = [];
                route.matched[route.matched.length - 1].query =
                    route.query || '';
                if (
                    route.matched[route.matched.length - 1].name ===
                        'settled' ||
                    route.matched[route.matched.length - 1].name ===
                        'technology' ||
                    route.matched[route.matched.length - 1].name ===
                        'carnival' ||
                    route.matched[route.matched.length - 1].name ===
                        'findMaterials'
                ) {
                    breadcrumbLang.value = true; //是否添加新类名，新类名的作用是将宽度改为1360px
                } else {
                    breadcrumbLang.value = false;
                }
                arr = [...route.matched];
                if (route.query.id_3 || route.query.id_2) {
                    arr.splice(1, 0, {
                        name: 'allCategories',
                        path: '/allCategories',
                        meta: {
                            title: '全部分类',
                        },
                    });
                }
                if (arr) {
                    breadcrumbArr.value = arr;
                }
            },
            { immediate: true },
        );
        const wwwUrl = ref(import.meta.env.VITE_SEO_HOST);
        return {
            breadcrumbItems,
            breadcrumbArr,
            breadcrumbLang,
            wwwUrl,
        };
    },
});
</script>

<template>
    <div :class="!breadcrumbLang ? 'breadcrumb' : 'breadcrumb breadcrumb-lang'">
        <!-- <a :href="wwwUrl">首页</a>
        <i>/</i>
        <p class="breadcrumb__inner">{{ breadcrumbArr[1].meta.title }}</p> -->
    </div>
</template>
<style lang="scss" scoped>
.breadcrumb {
    color: #606266;
    font-size: 14px;
    padding: 10px 0;
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    a {
        color: #303133;
    }
    i {
        padding: 0 5px;
        font-size: 12px;
        vertical-align: inherit;
        color: #ccc;
    }
    p {
        color: #828282;
    }
}

.breadcrumb-lang{
    width: 1360px;
}
</style>
<style lang="scss">
.el-breadcrumb {
    height: 48px;
    line-height: 48px;
    margin-left: 16px;
    margin: 0 auto;
    width: $inner-width;
}
.el-breadcrumb__inner,
.el-breadcrumb__inner a {
    font-weight: 400 !important;
    font-size: 14px !important;
}

/* 面包屑过渡动画 */
.breadcrumb-enter-active {
    transition: all 0.4s;
}

.breadcrumb-leave-active {
    transition: all 0.3s;
}

.breadcrumb-enter-from,
.breadcrumb-leave-active {
    opacity: 0;
    transform: translateX(20px);
}

.breadcrumb-leave-active {
    position: absolute;
}

.header_breadcrumb-lang {
    width: 1360px;
}
</style>
